/**
 * shared/lib/roles/index.ts — Single source of truth for platform-level role strings.
 *
 * Reconciles the historically-divergent spellings (`admin-platform`,
 * `platform_admin`, `strem_admin`) into ONE canonical constant (#494).
 *
 * Canonical value: `"admin-platform"`. This is the ONLY spelling that
 * `profiles.role` can hold — the column's insert schema pins it via
 * `z.enum(["individual", "pro", "admin-platform"])`
 * (shared/schema/tables-identity.ts). `platform_admin` / `strem_admin` are NOT
 * in that enum, so a `requireRole`/`profiles.role` comparison against either
 * NEVER matches (dead gate). Every gate that references the platform-admin role
 * MUST import PLATFORM_ADMIN_ROLE rather than re-spell the literal.
 *
 * Lives in `shared/` (not `server/middleware/`) so server/logic, routes, and
 * middleware can all consume one constant without crossing the
 * server/logic → server/middleware import boundary.
 */

/** The canonical `profiles.role` value for a Strenn platform operator/admin. */
export const PLATFORM_ADMIN_ROLE = "admin-platform" as const;

/** The literal type of the canonical platform-admin role string. */
export type PlatformAdminRole = typeof PLATFORM_ADMIN_ROLE;
